/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkTime
 */
export interface WorkTime {
    /**
     * 
     * @type {string}
     * @memberof WorkTime
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof WorkTime
     */
    workday: string;
    /**
     * 
     * @type {string}
     * @memberof WorkTime
     */
    weekend: string;
}

export function WorkTimeFromJSON(json: any): WorkTime {
    return WorkTimeFromJSONTyped(json, false);
}

export function WorkTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkTime {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'workday': json['workday'],
        'weekend': json['weekend'],
    };
}

export function WorkTimeToJSON(value?: WorkTime | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'workday': value.workday,
        'weekend': value.weekend,
    };
}


